import { decorate, observable } from 'mobx';
import flattenConfigurationModel from '../flattenConfigurationModel';

class EditStore {
    formModel;

    initModel(model) {
        this.formModel = model;
    }

    isNew = () => this.formModel.id.value == 0;

    getTransformedFormModel() {
        return flattenConfigurationModel(this.formModel);
    }
}

decorate(EditStore, {
    formModel: observable
})

export default EditStore;